import * as type from '../mutation-types'

export const managerStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      step1: 'manager/saveNameAndImage',
      password: 'manager/saveNewPassword',
      email: 'manager/saveNewEmail',
      saveManagerName: 'manager/saveManagerName',
      saveManagerImage: 'manager/saveManagerImage',
      deleteAccount: 'manager/deleteAccount'
    },
    managerImages: [
      '/static/game/manager/manager-1.png',
      '/static/game/manager/manager-2.png',
      '/static/game/manager/manager-3.png',
      '/static/game/manager/manager-4.png',
      '/static/game/manager/manager-5.png',
      '/static/game/manager/manager-6.png'
    ],
    name: '',
    imageId: 0,
    id: 0,
    managerSince: {},
    cacheTime: 0 // in sec
  },
  mutations: {
    [type.MANAGER_RESET] (state) {
      state.name = ''
      state.id = 0
      state.imageId = 0
      state.managerSince = {}
      state.cacheTime = 0
    },
    [type.MANAGER_SET_NAME] (state, name) {
      state.name = name
    },
    [type.MANAGER_SET_ID] (state, id) {
      state.id = id
    },
    [type.MANAGER_SET_IMAGE_ID] (state, id) {
      state.imageId = id
    },
    [type.MANAGER_SINCE] (state, data) {
      state.managerSince = data
    }
  },
  getters: {
    managerImage: (state, getters) => {
      return state.managerImages[state.imageId]
    },
    saveStep1Url: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.step1
    },
    saveNewPasswordUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.password
    },
    saveNewEmailUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.email
    },
    saveManagerName: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveManagerName
    },
    saveManagerImage: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveManagerImage
    },
    deleteAccount: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.deleteAccount
    }
  },
  actions: {
    async deleteAccount ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.deleteAccount,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // logout
        commit(type.ROOT_SET_SNACKBAR, 'Account gelöscht, DU wirst jetzt ausgeloggt', { root: true })
      } else {
        ret = false
        commit(type.ROOT_SET_SNACKBAR, 'Account konnte nicht gelöscht werden, bitte den Webmaster informieren!', { root: true })
      }

      return ret
    },
    async saveManagerImage ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.saveManagerImage,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set userimage as userimageid
        commit(type.MANAGER_SET_IMAGE_ID, payload.image)
        commit(type.ROOT_SET_SNACKBAR, 'Managerbild gespeichert', { root: true })
      } else {
        ret = false
        commit(type.ROOT_SET_SNACKBAR, 'Fehler beim speichern!!!', { root: true })
      }

      return ret
    },
    async saveManagerName ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.saveManagerName,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set username as managername
        commit(type.MANAGER_SET_NAME, payload.username)
        commit(type.ROOT_SET_SNACKBAR, 'Managername gespeichert', { root: true })
      } else {
        ret = false
        commit(type.ROOT_SET_SNACKBAR, 'Fehler beim speichern!!!', { root: true })
      }

      return ret
    },
    async saveManagerNameAndImage ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.saveStep1Url,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        // set userimage as userimageid
        commit(type.MANAGER_SET_IMAGE_ID, payload.image)
        // set username as managername
        commit(type.MANAGER_SET_NAME, payload.username)
        commit(type.ROOT_SET_SNACKBAR, 'Managername und Bild gespeichert', { root: true })
      } else {
        ret = false
        commit(type.ROOT_SET_SNACKBAR, 'Fehler beim speichern!!!', { root: true })
      }

      return ret
    },
    async saveNewPassword ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.saveNewPasswordUrl,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        commit(type.ROOT_SET_SNACKBAR, 'Passwort wurde gespeichert', { root: true })
      } else {
        ret = false
        commit(type.ROOT_SET_SNACKBAR, 'Fehler beim speichern!!!', { root: true })
      }

      return ret
    },
    async saveNewEmail ({ commit, getters, dispatch }, payload) {
      // set transport option
      const transportOptions = {
        url: getters.saveNewEmailUrl,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })
      let ret = true
      if (response.success) {
        commit(type.ROOT_SET_SNACKBAR, 'Bestätigungslink wurde versendet', { root: true })
      } else {
        ret = false
        commit(type.ROOT_SET_SNACKBAR, 'Fehler beim speichern!!!', { root: true })
      }

      return ret
    }
  }
}
